import { Component, h } from 'preact'
import { Group, GroupItem } from '../groups-destination/GroupOverview'
import Button from '../../control-components/ui-components/Button'
import Axios from 'axios'

interface Props {
  title: string
  groups: Group[]
  buttonLabel?: string
  buttonURL?: string
}

interface State {
  groups: Group[]
}

export class GroupsWidgetConfigurator extends Component<Props, State> {
  constructor (props: Props) {
    super(props)

    this.state = {
      groups: []
    }
  }

  async componentDidMount () {
    const res = await Axios.get('/getGroups', {
      params: {
        ids: this.props.groups.map(group => group.id)
      }
    })
    if (res.data && (res.data.myGroups.length || res.data.otherGroups.length)) {
      const newGroupList = this.props.groups.map((group: Group) => {
        const indexOfMyList = res.data.myGroups.findIndex((myGroup: Group) => myGroup.id === group.id)
        if (indexOfMyList !== -1) {
          return { ...res.data.myGroups[indexOfMyList], ...{ isUserMember: true } }
        } else {
          const indexOfOtherList = res.data.otherGroups.findIndex((myGroup: Group) => myGroup.id === group.id)
          return { ...res.data.otherGroups[indexOfOtherList], ...{ isUserMember: false } }
        }
      })
      this.setState({ groups: newGroupList })
    }
  }

  render ({ title, buttonLabel, buttonURL }: Props, { groups }: State) {
    const externalLink = buttonURL && (!buttonURL.includes(window.location.hostname))

    if (!groups.length) {
      return null
    }

    return (
      <section
        className='full-width Template-brand-featured homepage-widget-wrapper groups-container qa-groups-container custom-groups'
      >
        <div className='sitewidth'>
          <div className='col'>
            {
              title ? <h3 className='widget__heading'>{title}</h3> : null
            }
            <div className='group-overview'>
              {
                groups.map((group) => (
                  <GroupItem key={group.id} isEvenCount={groups.length === 2 || groups.length === 4} isUserMember {...group} />
                ))
              }
            </div>
            {buttonLabel && buttonURL &&
              <a
                class='featured-topics__show-more-button'
                href={buttonURL}
                target={`${externalLink ? '_blank' : '_self'}`}
                rel={`${externalLink ? 'noreferrer nofollow noopener' : ''}`}
              >
                <Button
                  title={buttonLabel}
                />
              </a>}
          </div>
        </div>
      </section>
    )
  }
}

export default GroupsWidgetConfigurator
